import { createReducer, on } from '@ngrx/store';
import {
  ClearState,
  FetchContractDetailsFailure,
  FetchContractDetailsRequest,
  FetchContractDetailsSuccess,
} from './contracts.actions';
import { ContractsModel } from '../../../../models/contracts.model';

// State for this feature (User)
export interface ContractsState {
  contractDetailsInfo: {
    contractDetails: ContractsModel;
    loading: boolean;
  };
}

const initialState: ContractsState = {
  contractDetailsInfo: {
    contractDetails: {
      weekNumber: null,
      weekStartDate: '',
      weekEndDate: '',
      session: [],
      participantName: '',
      rlGoal: null,
      paGoal: null,
      paDays: null,
      stGoal: null,
      strategy1: '',
      strategy2: '',
      strategy3: '',
      participantReward: '',
      support1: null,
      support2: null,
      support3: null,
      support4: null,
      support5: null,
      support6: null,
      support7: null,
      support8: null,
      support9: null,
      support10: null,
      support11: null,
      support12: null,
      support13: null,
      support14: null,
      supportOther: null,
      supportOtherText: '',
      adultReward: '',
      childSignature: null,
      participantSignature: '',
      adultSignature: null,
      adultSignatureText: '',
    },
    loading: false,
  },
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, () => initialState),

  // FETCH CONTRACT DETAILS
  on(FetchContractDetailsRequest, (state, props) => ({
    ...state,
    contractDetailsInfo: {
      ...initialState.contractDetailsInfo,
      loading: true,
    },
  })),
  on(FetchContractDetailsSuccess, (state, props) => ({
    ...state,
    contractDetailsInfo: {
      contractDetails: props.contractDetails,
      loading: false,
    },
  })),
  on(FetchContractDetailsFailure, (state) => ({
    ...state,
    contractDetailsInfo: initialState.contractDetailsInfo,
  })),
);
